import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GridService {
  private gridPaginationChanges = new Subject<any>();
  private gridCellEdit = new Subject<[any, boolean]>();

  gridPaginationChanged$ = this.gridPaginationChanges.asObservable();
  gridCellEdited$ = this.gridCellEdit.asObservable();

  onPaginationChanged(item: any, pageNo: any, pageSize: any, gridName?: any) {
    this.gridPaginationChanges.next([item, pageNo, pageSize, gridName]);
  }

  onCellEdit(params: any, isSingleClickEdit: boolean) {
    this.gridCellEdit.next([params, isSingleClickEdit]);
  }
}
